<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('deviceManagement') }} > {{ $t('ParameterConfiguration') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- form 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('configurationCategory')">
            <el-input v-model="formInline.categoryCode" clearable :placeholder="$t('configurationCategory')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('configurationDescription')">
            <el-input
              v-model="formInline.description"
              clearable
              :placeholder="$t('configurationDescription')"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="searchList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="add-btn" @click="addSysProperty">{{ $t('newlyAded') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table开始 -->
        <el-table
          :data="tableData"
          :row-key="getRowKeys"
          :expand-row-keys="expands"
          style="width: 100%;"
          @sort-change="sortChange"
        >
          <el-table-column type="index" :label="$t('SerialNo')" align="center" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column type="expand" width="1">
            <!-- 子table 添加进column -->
            <template slot-scope="scopeOut">
              <el-table
                :data="childTableData"
                v-show="scopeOut.row.codeInfo"
                border
                class="child-table"
                height="350"
                style="width: 90%; margin-left: 5%"
                @sort-change="sortChildChange"
              >
                <el-table-column type="index" :label="$t('SerialNo')" width="80" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="propertyKey" :label="$t('configurationName')" align="left"> </el-table-column>
                <el-table-column prop="propertyValue" :label="$t('bonfigurationValue')" align="left"></el-table-column>
                <el-table-column
                  prop="description"
                  :label="$t('configurationDescription')"
                  align="left"
                ></el-table-column>
                <el-table-column prop="categoryCode" :label="$t('configurationCategory')" align="left">
                </el-table-column>
                <el-table-column :label="$t('operationh')" width="180" align="center">
                  <template slot="header" slot-scope="scope">
                    <span class="add-btn child-add" @click="addChildPro(scope.row)">{{ $t('newlyAded') }}</span>
                  </template>
                  <template slot-scope="scope">
                    <span class="editClick" @click="editChildInfo(scope.row)">{{ $t('edit') }}</span>
                    <span class="editClick" @click="delectChildInfo(scope.row)">{{ $t('delete') }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <!-- 子table结束 -->
          <el-table-column
            prop="description"
            :label="$t('configurationDescription')"
            align="left"
            sortable="description"
          >
            <template slot-scope="scopeOut">
              <span class="category-scope" @click="expandTable(scopeOut.row)">{{ scopeOut.row.description }}</span>
            </template>
          </el-table-column>
          <!-- 点击 配置类别展开当行的子table  -->
          <el-table-column
            prop="categoryCode"
            :label="$t('configurationCategory')"
            align="left"
            sortable="categoryCode"
          >
          </el-table-column>
          <el-table-column :label="$t('operationh')" width="180" align="center">
            <template slot-scope="scope">
              <span class="editClick" @click="editPropertyInfo(scope.row)">{{ $t('edit') }}</span>
              <span class="editClick" @click="delectInfo(scope.row)">{{ $t('delete') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 外层频道弹窗 -->
    <el-dialog
      :title="
        editSysProperty ? $t('newlyAded') + $t('ParameterConfiguration') : $t('edit') + $t('ParameterConfiguration')
      "
      :visible.sync="dialogSysProperty"
      :append-to-body="true"
      class="common-blue-contain"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="fromData">
        <div class="settingDialog">
          <el-form-item :label="$t('configurationCategory')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromData.categoryCode"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('configurationCategory')"
              :disabled="editSysProperty ? false : true"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('configurationDescription')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromData.description"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('configurationDescription')"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSysProperty">{{ $t('determine') }}</el-button>
        <el-button @click="dialogSysProperty = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 系统配置子弹窗 -->
    <el-dialog
      :title="editChildProperty ? $t('addSystemConfiguration') : $t('systemConfigurationSub')"
      :visible.sync="childSysProperty"
      :append-to-body="true"
      class="common-blue-contain"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="fromChildData">
        <div class="settingDialog">
          <el-form-item :label="$t('subCnfigurationCategory')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromChildData.valueCategoryCode"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('subCnfigurationCategory')"
              :disabled="true"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('subConfigurationName')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromChildData.propertyKey"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('subConfigurationName')"
              @blur="_getCheckKey"
              :disabled="editChildProperty ? false : true"
              clearable
            ></el-input>
            <i class="tip" v-if="showTip">{{ $t('theSubConfigurationName') }}</i>
          </el-form-item>
          <el-form-item :label="$t('subConfigurationValue')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromChildData.propertyValue"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('subConfigurationValue')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('subConfigurationDscription')" :label-width="formLabelWidth" :required="true">
            <el-input
              v-model="fromChildData.description"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('subConfigurationDscription')"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChildSys(editChildProperty)">{{ $t('determine') }}</el-button>
        <el-button @click="childSysProperty = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { errorMessage, success } from '@/util/common'
import {
  getSysPropertyCodes,
  addSysPropertyCode,
  deleteSysPropertyCode,
  getOPERATION,
  addChildSysProperty,
  deleteChildSysProperty,
  editChildSysProperty,
  getCheckKey,
} from '@/api/setting'
import { errorCollection } from '@/api/dmp/dmpCollection'
export default {
  data() {
    return {
      // 查询表单form字段
      formInline: {
        categoryCode: '',
        description: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      dialogSysProperty: false,
      editSysProperty: false,
      // 外层弹窗 form字段
      fromData: {
        categoryCode: '',
        description: '',
      },
      formLabelWidth: '230px',
      expands: [],
      getRowKeys(row) {
        return row.categoryCode
      },
      codeInfo: false,
      editChildProperty: false,
      childSysProperty: false,
      // 子table弹窗form字段
      fromChildData: {
        valueCategoryCode: '',
        propertyKey: '',
        propertyValue: '',
        description: '',
      },
      childTableData: [],
      currentChild: [],
      showTip: false,
    }
  },
  methods: {
    // 子table排序
    sortChildChange({ column, prop, order }) {},
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.searchList()
    },
    _getCheckKey() {
      let param = {
        propertyKey: this.fromChildData.propertyKey,
        categoryCode: this.fromChildData.valueCategoryCode,
      }
      if (param.propertyKey !== '') {
        getCheckKey(param).then(res => {
          if (res.data) {
            this.showTip = true
          } else {
            this.showTip = false
          }
        })
      }
    },
    // 提交添加 子弹窗表单from
    submitChildSys(type) {
      // 表单填写的字段
      let param = {
        categoryCode: this.fromChildData.valueCategoryCode,
        description: this.fromChildData.description,
        propertyKey: this.fromChildData.propertyKey,
        propertyValue: this.fromChildData.propertyValue,
      }

      // 判断表单是否填入内容 提示
      if (this.fromChildData.propertyKey === '') {
        errorCollection('设置》参数配置', '添加子配置', { status: 200, data: { state: -1, msg: '请输入子配置名称' } })
        errorMessage(this.$t('pleaseEnter') + this.$t('subConfigurationName'))
        return
      } else if (this.fromChildData.propertyValue === '') {
        errorCollection('设置》参数配置', '添加子配置', { status: 200, data: { state: -1, msg: '请输入子配置值' } })
        errorMessage(this.$t('pleaseEnter') + this.$t('subConfigurationValue'))
        return
      } else if (this.fromChildData.description === '') {
        errorCollection('设置》参数配置', '添加子配置', { status: 200, data: { state: -1, msg: '请输入子配置描述' } })
        errorMessage(this.$t('pleaseEnter') + this.$t('subConfigurationDscription'))
        return
      } else {
        if (type === true) {
          // type 为true时：添加；false：编辑
          addChildSysProperty(param).then(res => {
            if (res.state === 0) {
              this.childSysProperty = false
              this.childConfig(this.currentChild)
            }
          })
        } else {
          editChildSysProperty(param).then(res => {
            if (res.state === 0) {
              this.childSysProperty = false
              this.childConfig(this.currentChild)
            }
          })
        }
      }
    },
    // 删除子 table row
    delectChildInfo(row) {
      console.log(row)
      this.$confirm(this.$t('deleteConfiguration'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = {
          propertyKey: row.propertyKey,
          categoryCode: row.categoryCode,
        }
        deleteChildSysProperty(param).then(res => {
          if (res.state === 0) {
            this.childSysProperty = false
            this.childConfig(this.currentChild)
          }
        })
      })
    },
    // 编辑子table row
    editChildInfo(row) {
      this.fromChildData = Object.assign({}, row) // 回显数据
      this.fromChildData.valueCategoryCode = this.currentChild.categoryCode
      this.editChildProperty = false // 区别弹窗 true：新增 false：编辑
      this.childSysProperty = true // 显示弹窗
    },
    // 添加子table row
    addChildPro() {
      this.fromChildData = {
        valueCategoryCode: '',
        propertyKey: '',
        propertyValue: '',
        description: '',
      }
      this.fromChildData.valueCategoryCode = this.currentChild.categoryCode
      this.editChildProperty = true
      this.childSysProperty = true
    },
    // 点击打开或收起 子table
    expandTable(row) {
      this.currentChild = []
      row.codeInfo = !row.codeInfo
      if (this.expands.length > 0) {
        // 判断是否已有打开的字table，>0: 有；清空关闭
        this.tableData.map(item => {
          if (item.categoryCode === this.expands[0]) {
            item.codeInfo = false
          }
        })
        this.expands = []
      }
      if (row.codeInfo) {
        // 展开点击行的 子table
        this.expands.push(row.categoryCode)
        this.childConfig(row)
        this.currentChild = row
      } else {
        this.expands = this.expands.filter(item => item !== row.categoryCode)
      }
      // console.log(this.expands, row.codeInfo, '配置类别')
    },
    // 提交table 编辑/新增 数据
    submitSysProperty() {
      let param = {
        categoryCode: this.fromData.categoryCode,
        description: this.fromData.description,
      }
      // 判断表单是否填入内容 提示
      if (this.fromData.categoryCode === '') {
        errorCollection('设置》参数配置', '编辑/新增配置', { status: 200, data: { state: -1, msg: '请输入配置类别' } })
        errorMessage(this.$t('pleaseEnter') + +this.$t('configurationCategory'))
        return
      } else if (this.fromData.description === '') {
        errorCollection('设置》参数配置', '编辑/新增配置', { status: 200, data: { state: -1, msg: '请输入配置描述' } })
        errorMessage(this.$t('pleaseEnter') + this.$t('configurationDescription'))
        return
      } else {
        // 输入完成后请求 添加/编辑 接口
        addSysPropertyCode(param).then(res => {
          if (res.state === 0) {
            this.dialogSysProperty = false
            this._getSysPropertyCodes()
          }
        })
      }
    },
    // 外层table添加
    addSysProperty() {
      // 清空 from表单
      this.fromData = {
        categoryCode: '',
        description: '',
      }
      this.dialogSysProperty = true // true: 弹窗显示，false: 关闭弹窗
      this.editSysProperty = true // true: 弹窗为新增，false: 弹窗为编辑
    },
    // 外层table 编辑
    editPropertyInfo(row) {
      this.fromData = Object.assign({}, row) // 回显数据
      this.dialogSysProperty = true
      this.editSysProperty = false
    },
    // 外层table 删除
    delectInfo(row) {
      this.$confirm(this.$t('deleteConfiguration'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { id: row.categoryCode }
        deleteSysPropertyCode(param).then(res => {
          if (res.state === 0) {
            success(this.$t('deleteSuccess'))
            this._getSysPropertyCodes()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._getSysPropertyCodes()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._getSysPropertyCodes()
    },
    // 根据条件进行查询
    searchList() {
      this.currentPage = 1
      this.expands = []
      this._getSysPropertyCodes()
    },
    // 外层table数据
    _getSysPropertyCodes() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        categoryCode: this.formInline.categoryCode,
        description: this.formInline.description,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getSysPropertyCodes(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
    },
    // 点击配置类别 打开子table，请求数据
    childConfig(row) {
      let param = {
        id: row.categoryCode,
      }
      getOPERATION(param).then(res => {
        if (res.state === 0) {
          this.childTableData = res.data
        }
      })
    },
  },
  created() {
    this._getSysPropertyCodes()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 640px
  min-height 460px;/* no */
  overflow: auto
.editClick
  margin-right 10px
  // color #00DEFF
.category-scope
  color #09f
  cursor pointer
  &:hover
    text-decoration underline
.child-table
  .child-add
    display inline-block
    width 50px; /* no */
    height 28px;/* no */
    line-height 28px;/* no */
    border-radius 4px; /* no */
    font-weight normal
    background-color var(--button-blue)
    cursor pointer
    color: var(--btn-color);
    // border 1px solid #00deff
    &:hover
      color #fff
      background-color var(--button-blue)
.tip
  display block
  font-size 12px
  line-height 18px;/*no*/
  color red
.main >>> .el-table__expand-icon:after
  content ''
.main >>> .el-table__expand-icon > i
  display none
.main >>> .el-table__expand-column
  border-right none
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 635px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
